<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <!-- ========================================== PC ============================================== -->
    <div v-if="this.verticalNavMenuWidth === 'default'" class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!--        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />-->

        <!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

        <!--<vs-button class="px-3 mr-3" color="primary" type="border" @click="openLink">현장 센서 모니터링</vs-button>-->

        <!--        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="UserIcon" @click.stop="handleUserIcon" />-->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />

        <label class="proj-name">{{ projectName }}</label>
        <vs-spacer />

        <!--<search-bar class="mr-4" />-->

        <notification-drop-down />

        <profile-drop-down />

        <i18n-drop-down v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" />
        <label v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" class="mr-1" style="cursor: pointer" @click="onChangeWorkType">
          <feather-icon :icon="`${selectWorkType}Icon`" />
        </label>
      </vs-navbar>
    </div>
    <!-- ========================================== MOBILE ============================================== -->
    <div v-else class="" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <label class="proj-name">{{ projectName }}</label>
        <!-- <vs-spacer /> -->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />
        <notification-drop-down />

        <profile-drop-down />

        <i18n-drop-down v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" />
        <label v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" class="mr-1" style="cursor: pointer" @click="onChangeWorkType">
          <feather-icon :icon="`${selectWorkType}Icon`" />
        </label>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import I18nDropDown from "./components/I18n.vue";
import config from "../../../../public/config";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    isSideMenu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    I18nDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { "text-white": (this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") || (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark") };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    projectName() {
      if (this.projectId) {
        return this.projectInfo.field_name;
      }
      return "";
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      selectWorkType: "Coffee",
    };
  },
  async mounted() {
    const _locale = await localStorage.getItem("i18n_locale");
    this.$i18n.locale = _locale;

    if (_locale) {
      const _tempList = _locale.split("_");
      if (_tempList[1] === "construct") {
        this.selectWorkType = "Tool";
      } else if (_tempList[1] === "produce") {
        this.selectWorkType = "Filter";
      } else if (_tempList[1] === "education") {
        this.selectWorkType = "Book";
      } else if (_tempList[1] === "maot") {
        this.selectWorkType = "Coffee";
      }
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },

    handleHomeIcon() {
      if (this.projectId) {
        this.$router.push(`/project/${this.projectId}`).catch(() => {});
      } else {
        this.$router.push("/").catch(() => {});
      }
    },

    handleUserIcon() {
      this.$router.push("/mypage/workstatus");
    },

    openLink() {
      const url = "https://wipco.senceive.com/Monitor/SiteMonitor.aspx";
      window.open(url, "_blank");
    },

    async onChangeWorkType() {
      if (this.selectWorkType === "Book") {
        this.selectWorkType = "Tool";
      } else if (this.selectWorkType === "Tool") {
        this.selectWorkType = "Filter";
      } else if (this.selectWorkType === "Filter") {
        this.selectWorkType = "Coffee";
      } else {
        this.selectWorkType = "Book";
      }

      const locale = this.$i18n.locale;
      if (locale) {
        const _tempList = locale.split("_");
        if (this.selectWorkType === "Tool") {
          await this.updateLocale(`${_tempList[0]}_construct`);
        } else if (this.selectWorkType === "Filter") {
          await this.updateLocale(`${_tempList[0]}_produce`);
        } else if (this.selectWorkType === "Book") {
          await this.updateLocale(`${_tempList[0]}_education`);
        } else if (this.selectWorkType === "Coffee") {
          await this.updateLocale(`${_tempList[0]}_maot`);
        }
      }
    },
    async updateLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        await localStorage.setItem("i18n_locale", locale);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.proj-name {
  border-left: 1px solid #dae1e7;
  padding-left: 8px;
  font-size: 18px;
}

.navbar-full {
  header {
    border-radius: 0px;

    label.proj-name {
      flex: 1;
      color: #606060;
      font-weight: 500;
      text-align: center;
      border: none;
      padding: 0;
    }
  }
}
</style>
